import { Stack, StackProps } from '@mui/material';

interface DrawerScreenLayoutProps extends StackProps {
    containerRef: React.RefObject<HTMLDivElement> | null;
}

const invisibleScroll = {
    overflowX: 'hidden',
    overflowY: 'auto',
    msOverflowStyle: 'none', // IE and Edge
    scrollbarWidth: 'none', // Firefox
    '&::-webkit-scrollbar': {
        display: 'none', // Chrome, Safari and Opera
    },
};

function DrawerScreenLayout({ children, containerRef, ...restProps }: DrawerScreenLayoutProps) {
    return (
        <Stack
            ref={containerRef}
            sx={{
                flex: 1,
                position: 'relative',
                backgroundColor: 'white',
                height: '100%',
                borderRadius: 3,
                ...invisibleScroll,
            }}
            direction="column"
            {...restProps}>
            {children}
        </Stack>
    );
}

export default DrawerScreenLayout;
